import { initialProps } from '@utils/initial'
import { routes } from '@group-devs/yfp7-global-modules/data/lcw'
import Error from '../404'
import { LcwLayout, SevenWaysHeader,SevenWaysBrain,MemoryLoss,TakeAPeek7Ways, AboutMe,FreeReport } from '@components/Block'
import { useAvatar } from '../../hooks/useAvatar'

export async function getServerSideProps({req, res, query}) {
    return {
        props: await initialProps(req, res, query, routes.sways)
    }
}

const SevenWaysMemory = (props) => {
    if (typeof props.err !== "undefined")
        return <Error statusCode={props.err.code} />

    const { avatar } = useAvatar(props.auth, props.site);

    return (
        <LcwLayout global={props}
            ogurl="/7ways-to-improve-memory" 
            ogsiteName="7 Ways to Improve Your Memory, Focus and Reduce Mental Decline"
            ogsiteDesc="Have you ever forgotten who you were calling after you dialed the phone? Memory loss is a frightening thing. If you’re worried about brain health, you’re not alone. Click to Download my Special Report." 
            ogImg="../images/7ways/img-7ways-share01.jpg"
            ogIcon="../images/7ways/img-favicon01.jpg"
        >
            
            <SevenWaysHeader global={props}/>
            <SevenWaysBrain/>
            <MemoryLoss global={props}/>
            <TakeAPeek7Ways/>
            <AboutMe global={props} avatar={avatar} />
            <FreeReport global={props}/>
        </LcwLayout>
    )
}

export default SevenWaysMemory